import React from "react";

import Table from "../../Common/Table";
import { getReadableDateTime, getPath } from "../../../utils";
import TableFields from "../../../constants/TdsAndRiderPayoutJobs/TableFields.json";
import BlankState from "../../Common/BlankState";
import { Heading } from "../../../constants/assets/containers";

const JobsList = (props) => {
  const getFieldValue = (item, key) => {
    switch (key) {
      case "start_time":
      case "end_time":
        return getReadableDateTime(item[key]);
      default:
        return item[key];
    }
  };

  const getHeading = () => {
    if (getPath(props, "jobs.length", 0) > 0) {
      if (props.activeJobType === "tds_deduction") {
        return "TDS Jobs";
      } else if (props.activeJobType === "rider_payout") {
        return "Rider Payout Jobs";
      }
    } else {
      return "";
    }
  };

  const jobsTable = (
    <Table
      list={props.jobs}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
  return (
    <>
      <div className="mb-24" date-testid="tdsAndRiderPayoutJobs_Heading">
        <Heading>{getHeading()}</Heading>
      </div>
      {getPath(props, "jobs.length", 0) > 0 ? jobsTable : <BlankState />}
    </>
  );
};

export default JobsList;
